<div class="modal-body _pop-overlay _math-key-popup">
  <div class="mid-panel">
    <div class="_pop-mid-content _math-key-popup">
      <div class="_math-key-mid">
        <div class="_top-icon">
          <img src="assets/images/popup-icon4.svg" alt="checkmark" />
        </div>
        <div class="heading">Terms and Condition</div>
        <div class="_form-section _terms-popup2">
          <div class="_left-form">
            <form [formGroup]="termsForm" (ngSubmit)="terms()">
              <!--form feild end-->
              <div class="form-field _checkbox _terms-under-age" *ngIf="this.type === 'google_signup'">
                <div class="form-group">
                  <input type="checkbox" id="check2" formControlName="isUserUnderAge" (change)="toChange()" />
                  <label for="check2"></label>
                </div>
                <div class="_terms">
                  <p>Check here if the user of this app is under 13 years of age</p>
                </div>
              </div>
              <!--form feild end-->

              <!--form feild end-->
              <div class="form-field" *ngIf="showParentEmail">
                <p class="_terms_parent_email">
                  Please enter an email of parent or guardian to receive privacy policy information. Educational institutions providing consent may
                  enter a school email instead.
                </p>
                <!--form feild start-->
                <div class="_field _icons parent_email_input">
                  <input type="text" formControlName="parentEmail" class="inputField" autocomplete="off" maxlength="75" />
                  <label for="" class="error-msg" *ngIf="f.parentEmail.errors?.required && f.parentEmail.touched && f.parentEmail.pristine">
                    {{ CommonConfig.validationMessage.emailRequired }}
                  </label>
                  <label for="" *ngIf="f.parentEmail.errors?.email && f.parentEmail.touched && f.parentEmail.dirty" class="error-msg">
                    {{ CommonConfig.validationMessage.emailInvalid }}
                  </label>
                  <label for="" *ngIf="f.parentEmail.errors?.invalidEmail && f.parentEmail.touched && f.parentEmail.dirty" class="error-msg">
                    {{ CommonConfig.validationMessage.emailInvalid }}
                  </label>
                </div>
              </div>
              <!--form feild end-->

              <div class="form-field _checkbox">
                <div class="form-group">
                  <input type="checkbox" id="check3" formControlName="isTermsAndCondition" />
                  <label for="check3"></label>
                </div>
                <div class="_terms">
                  <p>
                    By checking this box, I agree to the <a (click)="showTerms('Terms')">Terms of Service</a> and
                    <a (click)="showTerms('Privacy')">Privacy Policy</a>. If you are under 18 years old, you need to have a parent, guardian, or
                    school official check this box.
                  </p>
                  <label
                    for=""
                    *ngIf="f.isTermsAndCondition.errors?.required && f.isTermsAndCondition.touched && f.isTermsAndCondition.pristine"
                    class="error-msg"
                  >
                    {{ CommonConfig.validationMessage.termsAndConditionRequired }}
                  </label>
                </div>
              </div>
              <div class="form-field _submit terms_submit">
                <button type="button" (click)="closeModal()" class="button">Cancel</button>
                <button type="submit" class="button secondary">Okay</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
